module.exports = __webpack_public_path__ + "static/img/case-7laji.5c9ee5d6.jpg";